import Api from "../api/api";
import { useQuery } from "react-query";

const getResources = async (_, page) => {
  const { data } = await Api.get(`social?category=resources&page=${page}`);
  return data.data;
};

export default (props) => {
  return useQuery(["resources", props], getResources);
};
